exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rg-widget-review-item[data-v-ffb213e0]{background:#fafafa;line-height:26px;border-radius:10px}.rg-widget-review-item.in-content[data-v-ffb213e0]{float:left;width:33%;display:inline-block}.rg-widget-review-item .v-rating[data-v-ffb213e0]{display:inline-block;margin-left:0;margin-top:-1px}.rg-widget-review-item h3[data-v-ffb213e0]{display:inline-block;padding-top:3px;font-weight:700;margin-right:10px}.rg-widget-review-item .v-chip[data-v-ffb213e0]{float:right}", ""]);

// exports
